module.exports = __webpack_public_path__ + "assets/fast-forward.png?b3ab3360e9d3b921380698e4b7ab2e43";